const mission = [
    {    
        
        text: "Solving your problems, fast. After that, seeing you again to discuss how to solve more challenges!  Avoid planned obsolescence, facilitate your growth and remove all obstacles between you and your customers"
    }
  
]

export default mission
